import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { a11y } from '~js/components/a11y';

export class DelayShow {
  constructor(popupContainer, popup) {
    this.popupContainer = popupContainer;
    this.popup = popup;
    this.popupBody = popup.querySelector(s.selectors$d.popupBody);
    this.delay = popupContainer.dataset.popupDelay;
    this.isSubmitted =
      window.location.href.indexOf('accepts_marketing') !== -1 ||
      window.location.href.indexOf('customer_posted=true') !== -1;
    this.a11y = a11y;
    this.showPopupOnScrollEvent = () => this.showPopupOnScroll();

    if (this.delay === 'always' || this.isSubmitted) {
      this.always();
    }

    if (this.delay && this.delay.includes('delayed') && !this.isSubmitted) {
      const seconds = this.delay.includes('_') ? parseInt(this.delay.split('_')[1]) : 10;
      this.delayed(seconds);
    }

    if (this.delay === 'bottom' && !this.isSubmitted) {
      this.bottom();
    }

    if (this.delay === 'idle' && !this.isSubmitted) {
      this.idle();
    }
  }

  always() {
    this.showPopup();
  }

  delayed(seconds = 10) {
    setTimeout(() => {
      // Show popup after specific seconds
      this.showPopup();
    }, seconds * 1000);
  }

  // Scroll to the bottom of the page
  bottom() {
    document.addEventListener('theme:scroll', this.showPopupOnScrollEvent);
  }

  // Idle for 1 min
  idle() {
    const isTargetValid = this.checkPopupTarget() === true;
    if (!isTargetValid) {
      return;
    }

    let timer = 0;
    let idleTime = 60000;
    const documentEvents = [
      'mousemove',
      'mousedown',
      'click',
      'touchmove',
      'touchstart',
      'touchend',
      'keydown',
      'keypress',
    ];
    const windowEvents = ['load', 'resize', 'scroll'];

    const startTimer = () => {
      timer = setTimeout(() => {
        timer = 0;
        this.showPopup();
      }, idleTime);

      documentEvents.forEach((eventType) => {
        document.addEventListener(eventType, resetTimer);
      });

      windowEvents.forEach((eventType) => {
        window.addEventListener(eventType, resetTimer);
      });
    };

    const resetTimer = () => {
      if (timer) {
        clearTimeout(timer);
      }

      documentEvents.forEach((eventType) => {
        document.removeEventListener(eventType, resetTimer);
      });

      windowEvents.forEach((eventType) => {
        window.removeEventListener(eventType, resetTimer);
      });

      startTimer();
    };

    startTimer();
  }

  showPopup() {
    // Push every popup in array, so we can focus the next one, after closing each
    const popupElement = { id: this.popup.id, body: this.popupBody };
    popups.push(popupElement);

    const isTargetValid = this.checkPopupTarget() === true;

    if (isTargetValid) {
      activePopups += 1;
      this.popup.classList.add(c.classes$b.visible);
      if (this.popup.classList.contains(c.classes$b.popupBar)) {
        document.body.classList.add(c.classes$b.barIsVisible);
      }

      this.a11y.trapFocus({
        container: this.popupBody,
      });

      // The scroll is not locking if data-prevent-scroll-lock is added to the Popup container
      if (this.popup.hasAttribute(a.attributes$b.preventScrollLock)) {
        return false;
      }

      this.scrollLock();
    }
  }

  checkPopupTarget() {
    const targetMobile = this.popup.parentNode.classList.contains(c.classes$b.mobile);
    const targetDesktop = this.popup.parentNode.classList.contains(c.classes$b.desktop);

    if (
      (targetMobile && window.innerWidth >= theme.sizes.small) ||
      (targetDesktop && window.innerWidth < theme.sizes.small)
    ) {
      return false;
    } else {
      return true;
    }
  }

  scrollLock() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.popupBody }));
  }

  showPopupOnScroll() {
    if (window.scrollY + window.innerHeight >= document.body.clientHeight) {
      this.showPopup();
      document.removeEventListener('theme:scroll', this.showPopupOnScrollEvent);
    }
  }

  onUnload() {
    document.removeEventListener('theme:scroll', this.showPopupOnScrollEvent);
  }
}